import { render, staticRenderFns } from "./MobileBreadcrumb.vue?vue&type=template&id=2b6f29ae&v-if=%24vuetify.breakpoint.smAndDown"
import script from "./MobileBreadcrumb.vue?vue&type=script&lang=js"
export * from "./MobileBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports